import { useTranslation } from "react-i18next";
import { colors, fonts, useMediaQuery } from "../../Styles";
import { MainContentPaddingTypes, NewButtonList, NewModal } from "../BaseComponents";
import { ListStyle_Types } from "../../Definitions";

interface ConfirmModal_Props {
  disclaimer: string;
  onConfirm: () => void;
  onCancel: () => void;
  message?: string;
}

export default function ConfirmModal({ disclaimer, onConfirm, onCancel, message }: ConfirmModal_Props) {
  const { t } = useTranslation();
  const mobileXs = useMediaQuery(`(max-width: 650px)`);
  
  return (
    <NewModal
      header={""}
      overrides={{
        mainContentPadding: MainContentPaddingTypes.secondary,
        backgroundColor: colors.greyDarkPrimary,
        headerBakcgroundColor: colors.greyDarkPrimary,
        overlayColor: colors.blackPrimary + "99",
        headerHeight: "10px",
      }}
      mainContent={
        <p style={{ ...fonts.fontSize3, ...fonts.paragraph, color: colors.greyLightTertiary, textAlign: "center" }}>{disclaimer}</p>
      }
      footerContent={
        <div style={{margin: "0px 20px"}}>
          <NewButtonList
            contents={[t("buttons.confirm", { defaultValue: "confirm" }), t("buttons.cancel", { defaultValue: "cancel" })]}
            onClick={(i) => {
              if (i === 0) { onConfirm() }
              if (i === 1) { onCancel() }
            }}
            overrides={(i) => ({
              baseStyles: { backgroundColor: i === 0 ? colors.blueDarkPrimary : colors.greyDarkPrimary, border: i === 1 ? "3px solid "+colors.blueDarkPrimary : "none"},
              hoverStyles: { backgroundColor: i === 0 ? colors.blueDarkSecondary : colors.blueDarkPrimary },
            })}
            listOverrides={{
              listStyle: mobileXs ? ListStyle_Types.vertical : ListStyle_Types.horizontal,
              listGap: "10px"
            }}
          />
        </div>
      }
      footerMessage={message}
    />
  );
}